import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaArrowLeft } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';
import './Auth.css';

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [email, setEmail] = useState('');
  
  const { resetPassword } = useAuth();

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    // Basic validation
    if (!email) {
      setError('Please enter your email address');
      setLoading(false);
      return;
    }

    if (!email.includes('@')) {
      setError('Please enter a valid email address');
      setLoading(false);
      return;
    }

    try {
      const result = await resetPassword(email);
      if (result.success) {
        setSuccess('Password reset email sent! Please check your inbox.');
      } else {
        setError(result.error);
      }
    } catch (err) {
      setError('Failed to send reset email. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="container">
        <motion.div
          className="auth-container"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div className="auth-header">
            <Link to="/" className="logo">
              <img 
                src="/images/monogram/monogram_desktop_1756135549612_0.webp" 
                alt="Vastré by Vijh" 
                className="logo-image"
              />
            </Link>
            <h1>Reset Password</h1>
            <p>Enter your email to receive reset instructions</p>
          </div>

          <div className="auth-form">
            {/* Error and Success Messages */}
            {error && (
              <div className="auth-message error">
                <span>{error}</span>
              </div>
            )}
            {success && (
              <div className="auth-message success">
                <span>{success}</span>
              </div>
            )}

            <form onSubmit={handleResetPassword} className="auth-form-fields">
              <div className="form-group">
                <div className="input-wrapper">
                  <input
                    type="email"
                    placeholder="Email address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    className="form-input"
                  />
                </div>
              </div>

              <button 
                type="submit" 
                className="btn-primary reset-btn" 
                disabled={loading}
              >
                {loading ? 'Sending...' : 'Send Reset Email'}
              </button>
            </form>

            <div className="auth-footer">
              <Link to="/login" className="back-to-login">
                <FaArrowLeft className="back-icon" />
                <span>Back to Login</span>
              </Link>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default ForgotPassword;
